import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import FormInput from '../../../../components/Form/FormInput';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import { Button } from 'primereact/button';
import PropertyField from '../../../../components/Properties/PropertyField';

import { validateURL } from '../../../../utils/stringHelper';
import { CONSTANT } from '../../../../utils/constants';
import { Dropdown } from 'primereact/dropdown';

function EventManager({
  isOpen,
  event,
  onUpdate,
  loading,
  onCreate,
  emptyPayload,
  setPanelIsOpen
}) {
  const [title, setTitle] = useState('');
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [place, setPlace] = useState('');
  const [publicList, setPublicList] = useState([]);
  const [srcUrl, setSrcUrl] = useState('');
  const [srcLabel, setSrcLabel] = useState('');
  const [content, setContent] = useState('');
  const [format, setFormat] = useState('');

  useEffect(() => {
    if (event) {
      setTitle(event.title);
      setStartDate(new Date(event.start_dt));
      setPublicList(
        event?.public_list?.filter((ot) => ot.type === 'sy_public_list').map((ot) => ot.id)
      );
      setEndDate(new Date(event.end_dt));
      setPlace(event.place);
      setSrcLabel(event.src_label);
      setSrcUrl(event.src_url);
      setContent(event.content);
      setFormat(event.format);
    } else {
      setTitle('');
      setStartDate(undefined);
      setPublicList([]);
      setEndDate(undefined);
      setPlace('');
      setSrcLabel('');
      setSrcUrl('');
      setContent('');
      setFormat('');
    }
  }, [event, emptyPayload]);

  const handleValidate = () => {
    const eventPayload = {
      title,
      start_dt: startDate,
      end_dt: endDate,
      place,
      src_label: srcLabel,
      src_url: srcUrl,
      content,
      format,
      public_list: publicList
    };
    event ? onUpdate(eventPayload) : onCreate(eventPayload);
  };

  const onClose = () => {
    setPanelIsOpen(false);
  };

  const formIsValid = () => {
    return title.length > 3 && startDate && endDate && place;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${event ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 900 }}
      visible={isOpen}
      position="right"
      onHide={onClose}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${event ? 'Modifier' : 'Ajouter'} un Évènement`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="title" label={"Titre de l'évènement"} required isValid={title.length > 3}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de l'évènement"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput key="start_dt" label={'Date de début'} required isValid={startDate}>
            <Calendar
              id="start_dt"
              onChange={(e) => setStartDate(e.value)}
              placeholder="Veuillez selectionner la date de début"
              value={startDate}
              locale="fr"
              showTime
              hourFormat="24"
              stepMinute={15}
            />
          </FormInput>
          <FormInput key="end_dt" label={'Date de fin'} required isValid={endDate}>
            <Calendar
              id="end_dt"
              onChange={(e) => setEndDate(e.value)}
              placeholder="Veuillez selectionner la date de fin"
              value={endDate}
              locale="fr"
              showTime
              hourFormat="24"
              stepMinute={15}
              minDate={startDate}
            />
          </FormInput>
          <FormInput key="public_list" label={'Public cible'} required isValid={publicList.length}>
            <PropertyField
              type={'sy_public_list'}
              selectedPropertyList={publicList}
              setSelectedPropertyList={setPublicList}
              scope={'solarys'}
            />
          </FormInput>
          <FormInput key="place" label={"Lieu de l'évènement"} required isValid={place?.length > 3}>
            <InputText
              id="place"
              value={place}
              maxLength={300}
              placeholder="Veuillez saisir le lieu de l'évènement"
              onChange={(e) => setPlace(e.target.value)}
            />
          </FormInput>

          <FormInput key="format" label={'Format'} required isValid={format}>
            <Dropdown
              value={format}
              options={CONSTANT.solarys.formatList}
              optionLabel="label"
              onChange={(e) => setFormat(e.value)}
              placeholder="Indiquez le format de l'évènement"
              className="grow"
            />
          </FormInput>

          <FormInput
            key="src_label"
            label={"Url de l'évènement"}
            errorMessage={!validateURL(srcUrl) && "L'URL doit commencer par http:// ou https://"}
            required
            isValid={srcUrl?.length > 3}>
            <InputText
              id="src_url"
              value={srcUrl}
              maxLength={300}
              placeholder="Veuillez saisir l'url"
              onChange={(e) => setSrcUrl(e.target.value)}
              invalid={!validateURL(srcUrl)}
            />
          </FormInput>
          <FormInput key="src_label" label={'Titre url'} required isValid={srcLabel?.length > 3}>
            <InputText
              id="src_url"
              value={srcLabel}
              maxLength={300}
              placeholder="Veuillez saisir l'url de l'évènement"
              onChange={(e) => setSrcLabel(e.target.value)}
            />
          </FormInput>
          <FormInput key="content" label={'Description'}>
            <RichTextEditor
              value={content}
              onChange={(value) => {
                setContent(value);
              }}
              // height={'h-48'}
              acceptHeaders
            />
          </FormInput>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default EventManager;
